import { AiToolkitToolName } from "@mem-client/ai-toolkit/contract";
import {
  getAssistantFollowUpTool,
  searchAssistantFollowUpsTool,
} from "@/modules/ai-toolkit/tools/assistant-follow-ups";
import {
  getAssistantProjectTool,
  searchAssistantProjectsTool,
} from "@/modules/ai-toolkit/tools/assistant-projects";
import {
  createAssistantTaskTool,
  getAssistantTaskTool,
  searchAssistantTasksTool,
} from "@/modules/ai-toolkit/tools/assistant-tasks";
import {
  getCalendarEventTool,
  searchCalendarEventsTool,
} from "@/modules/ai-toolkit/tools/calendar";
import {
  addNoteToCollectionTool,
  getCollectionTool,
  listCollectionItemsTool,
  removeNoteFromCollectionTool,
  searchCollectionsTool,
} from "@/modules/ai-toolkit/tools/collections";
import {
  navigateToCollectionTool,
  navigateToNoteTool,
} from "@/modules/ai-toolkit/tools/navigation";
import {
  createNoteTool,
  getNoteTool,
  searchNotesTool,
  updateNoteTool,
} from "@/modules/ai-toolkit/tools/notes";

export * from "./assistant-follow-ups";
export * from "./assistant-projects";
export * from "./assistant-tasks";
export * from "./calendar";
export * from "./collections";
export * from "./navigation";
export * from "./notes";
export * from "./types";

export type AiToolkitToolsByName = {
  [AiToolkitToolName.GetNote]: typeof getNoteTool;
  [AiToolkitToolName.SearchNotes]: typeof searchNotesTool;
  [AiToolkitToolName.CreateNote]: typeof createNoteTool;
  [AiToolkitToolName.UpdateNote]: typeof updateNoteTool;
  [AiToolkitToolName.GetAssistantTask]: typeof getAssistantTaskTool;
  [AiToolkitToolName.SearchAssistantTasks]: typeof searchAssistantTasksTool;
  [AiToolkitToolName.CreateAssistantTask]: typeof createAssistantTaskTool;
  [AiToolkitToolName.GetAssistantProject]: typeof getAssistantProjectTool;
  [AiToolkitToolName.SearchAssistantProjects]: typeof searchAssistantProjectsTool;
  [AiToolkitToolName.GetAssistantFollowUp]: typeof getAssistantFollowUpTool;
  [AiToolkitToolName.SearchAssistantFollowUps]: typeof searchAssistantFollowUpsTool;
  [AiToolkitToolName.GetCalendarEvent]: typeof getCalendarEventTool;
  [AiToolkitToolName.SearchCalendarEvents]: typeof searchCalendarEventsTool;
  [AiToolkitToolName.GetCollection]: typeof getCollectionTool;
  [AiToolkitToolName.SearchCollections]: typeof searchCollectionsTool;
  [AiToolkitToolName.ListCollectionItems]: typeof listCollectionItemsTool;
  [AiToolkitToolName.AddNoteToCollection]: typeof addNoteToCollectionTool;
  [AiToolkitToolName.RemoveNoteFromCollection]: typeof removeNoteFromCollectionTool;
  [AiToolkitToolName.NavigateToNote]: typeof navigateToNoteTool;
  [AiToolkitToolName.NavigateToCollection]: typeof navigateToCollectionTool;
};

export const aiToolkitToolsByName: AiToolkitToolsByName = {
  [AiToolkitToolName.GetNote]: getNoteTool,
  [AiToolkitToolName.SearchNotes]: searchNotesTool,
  [AiToolkitToolName.CreateNote]: createNoteTool,
  [AiToolkitToolName.UpdateNote]: updateNoteTool,
  [AiToolkitToolName.GetAssistantTask]: getAssistantTaskTool,
  [AiToolkitToolName.SearchAssistantTasks]: searchAssistantTasksTool,
  [AiToolkitToolName.CreateAssistantTask]: createAssistantTaskTool,
  [AiToolkitToolName.GetAssistantProject]: getAssistantProjectTool,
  [AiToolkitToolName.SearchAssistantProjects]: searchAssistantProjectsTool,
  [AiToolkitToolName.GetAssistantFollowUp]: getAssistantFollowUpTool,
  [AiToolkitToolName.SearchAssistantFollowUps]: searchAssistantFollowUpsTool,
  [AiToolkitToolName.GetCalendarEvent]: getCalendarEventTool,
  [AiToolkitToolName.SearchCalendarEvents]: searchCalendarEventsTool,
  [AiToolkitToolName.GetCollection]: getCollectionTool,
  [AiToolkitToolName.SearchCollections]: searchCollectionsTool,
  [AiToolkitToolName.ListCollectionItems]: listCollectionItemsTool,
  [AiToolkitToolName.AddNoteToCollection]: addNoteToCollectionTool,
  [AiToolkitToolName.RemoveNoteFromCollection]: removeNoteFromCollectionTool,
  [AiToolkitToolName.NavigateToNote]: navigateToNoteTool,
  [AiToolkitToolName.NavigateToCollection]: navigateToCollectionTool,
};
